let banWords = []

const replaceBanWord = (banWords, message) => {
  let count = 0
  banWords.forEach(word => {
    // 금칙어를 메시지 내용이 포함 하는지 확인
    if (message.indexOf(word) > -1) {
      // 금칙어가 포함이면 금칙어 카운트 추가
      count += 1

      // span 으로 감쌀 금칙어를 문자별로 나눔
      let splitWord = word.split('')
      let changeWord = ''

      // 금칙어 글자 하나하나를 span 으로 감싼다
      splitWord.forEach(s => {
        changeWord += s.replace(s, banWordSpan(s))
      })

      // 금칙어를 정규식으로 모든 내용을 찾아서 위에서 span 으로 글자글자 감싼것으로 대체
      message = message.replace(new RegExp(word, 'gi'), changeWord)
    }
  })
  message = message.replace(/&#60;/gi, '<span style=color:#ffffff;text-decoration:underline;text-decoration-color:#D0D0D0;>')
  message = message.replace(/&#62;/gi, '</span>')
  return {
    message: message,
    count: count
  }
}

const banWordSpan = (char) => {
  return '&#60;' + char + '&#62;'
}

const replaceBanWordToStar = (banWords, message) => {
  let replaceWord = message
  banWords.forEach(word => {
    // 금칙어를 메시지 내용이 포함 하는지 확인
    while (replaceWord.indexOf(word) > -1) {
      let indexNum = replaceWord.indexOf(word)
      replaceWord = replaceWord.replace(replaceWord.substring(indexNum, indexNum + word.length), generateStar(word.length))
    }
  })
  return replaceWord
}

const isContainBanWord = (banWords, message) => {
  let result = false
  result = banWords.some(b => {
    if (message.includes(b)) {
      return true
    }
  })
  return result
}

const generateStar = (count) => {
  let str = ''
  for (let i = 0; i < count; i++) {
    str += '*'
  }
  return str
}

const xssCheck = (str) => {
  if (str) {
    /* eslint-disable */
    str = str.replace(/\</g, '&lt;')
    str = str.replace(/\>/g, '&gt;')
    /* eslint-enable */
  }
  return str
}

const replaceUrl = (message, fontStyle) => {
  // http, https, mail 및 프로토콜 미지정 URL 링크 태그 추가
  const protocolReg = '(http://|https://|mailto:|)'
  const domainReg = '([0-9a-zA-Z](?:[-_.]?[0-9a-zA-Z])+@)?[a-z0-9]+(?:[\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(?::[0-9]{1,5})?'
  const subPathReg = '(?:/[^\\s]*)?'
  const regURL = new RegExp(protocolReg + '?(' + domainReg + subPathReg + ')', 'gi')
  const result = regURL.exec(message)
  if (result) {
    const target = result[0]
    const mailId = result[3]
    const protocol = result[1] ? result[1] : (mailId ? 'mailto:' : 'http://')
    const url = result[2]

    const backgroundColor = fontStyle.hasOwnProperty('background-color') ? fontStyle['background-color'] : ''
    const color = fontStyle.hasOwnProperty('color') ? fontStyle['color'] : ''
    const style = 'background-color:' + backgroundColor + ';color:' + color + ';text-decoration:underline'

    message = message.replace(target, '<a href="' + protocol + url + '" target="_blank" style="' + style + '">' + target + '</a>')
  }
  return message
}

const setBanWords = (data) => {
  banWords = data
}

const getBanWords = () => {
  return banWords
}

export default {
  replaceBanWord,
  replaceBanWordToStar,
  xssCheck,
  replaceUrl,
  setBanWords,
  getBanWords,
  isContainBanWord
}



// WEBPACK FOOTER //
// ./src/util/messages.js